import ThreadAvatar from '../threads/ThreadAvatar';
import useThreadParticipantBestProfile from '../threads/useThreadParticipantBestProfile';
import { InboxMessageAvatarContainer } from './InboxMessages.styles';

const InboxMessageAvatar = ({
  senderName,
  threadUid,
}: {
  senderName: string;
  threadUid: string;
}) => {
  const threadParticipantBestProfile =
    useThreadParticipantBestProfile(threadUid);
  const bestProfile = senderName
    ? { name: senderName }
    : threadParticipantBestProfile;
  return (
    <InboxMessageAvatarContainer>
      <ThreadAvatar bestProfile={bestProfile} />
    </InboxMessageAvatarContainer>
  );
};

export default InboxMessageAvatar;
